<template>
  <BaseAutoCompleteWithMultipleSelectedItems
    v-model="modelValue"
    @blur="emitBlur"
    label="対応型番"
    itemName="type"
    :items="items"
    :error-messages="errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithMultipleSelectedItems from '@/components/AutoCompletes/BaseAutoCompleteWithMultipleSelectedItems.vue';
import deviceType from '@/types/DeviceType';
import { visibleDeviceTypes } from '@/services/consts';
import { ref, computed } from 'vue';

const props = defineProps<{
  modelValue: deviceType[];
  errorMessages?: string[];
}>();

const emit = defineEmits(['update:modelValue', 'blur']);

const items = ref<deviceType[]>(visibleDeviceTypes);

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const emitBlur = () => {
  emit('blur');
};
</script>
